import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';

const styles = theme => ({
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
});

const ButtonWithConfirmation = ({ buttonText, dialogTitle, dialogContent, onSubmit, classes, ...props }) => {
  const [open, setOpen] = useState(false);

  function handleClick() {
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }
  function handleSubmit() {
    onSubmit();
    setOpen(false);
  }

  const formMethods = useForm();

  return (
    <>
      <MuiButton {...props} onClick={handleClick}>
        {buttonText}
      </MuiButton>
      <MuiDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <MuiDialogTitle id="form-dialog-title">{dialogTitle}</MuiDialogTitle>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <MuiDialogContent>{dialogContent}</MuiDialogContent>
          <MuiDialogActions className={classes.dialogFooter}>
            <MuiButton variant="contained" onClick={handleClose}>
              Cancel
            </MuiButton>
            <MuiButton variant="contained" color="primary" type="submit">
              Ok
            </MuiButton>
          </MuiDialogActions>
        </form>
      </MuiDialog>
    </>
  );
};

export default withStyles(styles)(ButtonWithConfirmation);
